import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { postLoginUser } from '../../actions/auth';
import { Button, CssBaseline, TextField, Container, Paper, InputAdornment } from '@mui/material';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import eyeShut from '../../img/icons8-eye-50.png';
import eyeOpen from '../../img/icons8-eye-50-2.png';
import backgroundImage from "../../img/LEVLR-Login-Background.jpg";
import levlr_logo from "../../img/LEVLR Logo_CMYK.png";

const LoginFormInner = () => {
  const [credentials, setCredentials] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const state = useSelector(state => state);
  const isLoggedIn = useSelector(state => state.isLoggedIn);
  const user = useSelector(state => state.user);
  const answeredQuestions = useSelector(state => state.additional_questions_answered);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    if (!isLoggedIn) return;
  
    console.log("state: ", state);
    console.log("answeredQuestions: ", answeredQuestions);
  
    const requestedPath = location?.state?.from?.pathname;
    const safeRequestedPath = requestedPath && requestedPath !== '/login' ? requestedPath : null;

    if (answeredQuestions === false) {
      navigate('/postRegistration', { replace: true });
    }  else {
      navigate(safeRequestedPath || '/createNewComparison', { replace: true });
    }
  }, [isLoggedIn, answeredQuestions, navigate, location]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: name === "email" ? value.toLowerCase().trim() : value.trim(),
    }));
  };

  const loginUser = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!executeRecaptcha) {
      setErrorMessage("Recaptcha not ready. Please try again later.");
      return;
    }

    try {
      const recaptchaToken = await executeRecaptcha('loginUser');
      await dispatch(postLoginUser({ credentials, recaptchaToken }));
    } catch (err) {
      setErrorMessage(err.message || "Login failed. Check your credentials.");
    }
  };

  const routeChange = () => navigate('/register');
  const passwordChange = () => navigate('/forgot');

  const styles = {
    backGround: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `url(${backgroundImage})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      height: '100vh',
      padding: '10% 0',
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255,0.5)',
      width: '70%',
      padding: '4vh 0',
      margin: '0 auto',
    },
    textField: { width: '65%', marginBottom: '1rem', backgroundColor: '#eff0f0', borderRadius: 4 },
    button: { width: '50%', color: '#fff', margin: '8px 0' },
    loginBtn: { backgroundColor: '#2fb7b7', '&:hover': { backgroundColor: '#01656a' } },
    signupBtn: { backgroundColor: '#01656a', '&:hover': { backgroundColor: '#2fb7b7' } },
    logo: { width: '40%', height: 'auto', marginBottom: '1rem' }
  };

  if (!user) return null;

  return (
    <div style={styles.backGround}>
      <Container component="main">
        <CssBaseline />
        <Paper style={styles.paper}>
          <img src={levlr_logo} alt="Levlr Logo" style={styles.logo} />
          <form onSubmit={loginUser} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} noValidate>
            <TextField
              variant="outlined"
              label="Email"
              name="email"
              required
              autoFocus
              onChange={handleChange}
              style={styles.textField}
            />
            <TextField
              variant="outlined"
              label="Password"
              name="password"
              required
              type={showPassword ? 'text' : 'password'}
              onChange={handleChange}
              style={styles.textField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                      <img src={showPassword ? eyeShut : eyeOpen} alt="toggle password" style={{ width: 24, height: 24 }} />
                    </button>
                  </InputAdornment>
                )
              }}
            />
            <Button type="submit" variant="contained" style={{ ...styles.button, ...styles.loginBtn }}>LOGIN</Button>

            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}

            <span>Don't have an account?</span>
            <Button onClick={routeChange} variant="contained" style={{ ...styles.button, ...styles.signupBtn }}>SIGN UP</Button>

            <span>Forgot Your Password?</span>
            <Button onClick={passwordChange} variant="contained" style={{ ...styles.button, ...styles.signupBtn }}>Reset Password</Button>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

const LoginForm = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <LoginFormInner />
  </GoogleReCaptchaProvider>
);

export default LoginForm;
